import React from 'react';

import { dataHora } from '../formatacao';

interface Props {
  baixadoEm: string | null;
  origem: 'SERVIDOR' | 'LOCAL' | 'NENHUM';
}

/**
 * Quando este aparelho baixou os dados (25/09/2026).
 *
 * 🔴 **Estava DENTRO da barra de sincronização, e as duas informações se confundiam**: a barra
 * fala do que SAI do aparelho ("Tudo enviado" — nada na fila) e o carimbo, do que ENTROU nele
 * (a lista de veículos e o checklist). Lidas como uma coisa só, "Tudo enviado · Dados de 25/09"
 * sugere que está tudo em dia — quando é perfeitamente possível ter a fila vazia e uma lista de
 * três dias atrás, e o inspetor procurar na oficina um carro que já saiu.
 *
 * Texto e cor são os do carimbo do Contac (`Dados atualizados em: …` em 12px/#888) — decisão do
 * Victor: o mesmo dado tem a mesma cara em todo o sistema. ⚠️ A POSIÇÃO diverge: aqui ele fica no
 * canto superior direito do cabeçalho, e não sob o título (pedido dele em 25/09/2026, na mesma
 * conversa em que o botão "Atualizar dados" desceu para a barra de ações).
 */
const CarimboDeDados: React.FC<Props> = ({ baixadoEm, origem }) => {
  // ⚠️ Âmbar, e não a cor normal: aqui não há data nenhuma a exibir, e a leitura errada
  // ("os dados estão em dia") é a cara. É o mesmo tratamento que o Contac dá ao estado em que
  // não conseguiu verificar a data.
  if (origem === 'NENHUM' || !baixadoEm) {
    return (
      <p style={{ fontSize: 12, color: 'var(--tema-texto-laranja, #b26a00)', margin: '4px 0 0 0' }}>
        Este aparelho ainda não baixou os dados.
      </p>
    );
  }

  return (
    <p style={{ fontSize: 12, color: 'var(--tema-texto-3, #888)', margin: '4px 0 0 0' }}>
      Dados atualizados em: {dataHora(baixadoEm)}
      {origem === 'LOCAL' && ' (guardados neste aparelho)'}
    </p>
  );
};

export default CarimboDeDados;
